import { useCallback, useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';

import { SUBSCRIPTION_CONNECTION_STATUS } from '../../graphql/subscriptionConnection';

const DEFAULT_CONNECTION_STATE = {
	status: SUBSCRIPTION_CONNECTION_STATUS.IDLE,
	hasConnected: false,
	recoveryCount: 0,
};

const useSubscriptionConnection = () => {
	const apolloClient = useApolloClient();
	const { subscriptionConnection } = apolloClient;
	const [connectionState, setConnectionState] = useState(() => (
		subscriptionConnection?.getState() || DEFAULT_CONNECTION_STATE
	));

	useEffect(() => {
		if (!subscriptionConnection) {
			return undefined;
		}

		setConnectionState(subscriptionConnection.getState());
		return subscriptionConnection.subscribe(setConnectionState);
	}, [subscriptionConnection]);

	const reconnect = useCallback(() => {
		subscriptionConnection?.requestReconnect();
	}, [subscriptionConnection]);

	return {
		...connectionState,
		reconnect,
	};
};

export default useSubscriptionConnection;
